import { render } from "./NotPromotor.vue?vue&type=template&id=3bbff122"
import script from "./NotPromotor.vue?vue&type=script&lang=js"
export * from "./NotPromotor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__